<template>
  <section ref="childPage">
    <a-form class="form-container m-t-18" :form="form">
      <section class="form-item">
        <p class="title">车辆信息</p>
        <a-row type="flex" :gutter="20">
          <a-col :span="8">
            <a-form-item label="单位名称">
              <a-select
                showSearch
                :filterOption="filterOption"
                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                option-filter-prop="children"
                placeholder="请选择"
                v-decorator="[
                  'companyId',
                  { rules: [{ required: false, message: '请选择单位' }] },
                ]"
              >
                <a-select-option
                  v-for="item in companyMap"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.companyName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="车辆类型">
              <a-select
                placeholder="请选择"
                v-decorator="[
                  'carType',
                  { rules: [{ required: true, message: '请选择车辆类型' }] },
                ]"
              >
                <a-select-option
                  v-for="item in carTypeMap"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.carTypeName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="车牌号">
              <a-input
                placeholder="请输入"
                v-decorator="[
                  'carNumber',
                  {
                    rules: [
                      { required: true, message: '请输入车牌号' },
                      { validator: validator.carNumberReg },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row type="flex" :gutter="20">
          <a-col :span="8">
            <a-form-item label="司机姓名">
              <a-input
                placeholder="请输入"
                v-decorator="[
                  'carName',
                  {
                    rules: [
                      { required: false, message: '司机姓名不能为空' },
                      { max: 5, message: '最大输入5个字符' },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="联系电话">
              <a-input
                placeholder="请输入"
                v-decorator="[
                  'carBrand',
                  {
                    rules: [
                      { required: false, message: '联系电话不能为空' },
                      { validator: validator.phoneReg },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row type="flex">
          <a-col :span="8">
            <a-form-item label="车辆照片">
              <a-row class="upload-preview-wrap">
                <a v-if="files.url" class="file-item m-r-10" style="top: -20px">
                  <a-avatar shape="square" :size="100" :src="files.url" />
                </a>
              </a-row>
              <upload
                style="display: inline-block; width: 100px"
                v-decorator="[
                  'carImage',
                  { rules: [{ required: false, message: '请上传照片' }] },
                ]"
                :node="{ type: 3, text: '上传' }"
                :accept="['.png', '.jpg']"
                @func="uploadFile"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row type="flex" :gutter="20">
          <a-col :span="24">
            <a-form-item label="备注说明">
              <a-textarea
                placeholder="请输入"
                :rows="4"
                v-decorator="[
                  'remarks',
                  {
                    rules: [
                      { required: false, message: '请输入备注说明' },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </section>

      <!-- 资料文件 -->
      <section class="form-item m-t-10">
        <p class="title">
          资料文件
          <a class="action-btn" @click="showFileDataModal(null)">
            <a-icon type="plus" />
          </a>
        </p>
        <section class="list-table-container">
          <a-table
            :bordered="false"
            size="small"
            class="m-t-18"
            :columns="fileData.columns"
            :data-source="fileData.data"
            :pagination="false"
          >
            <a-row v-if="list.fileUrl" slot="fileUrl" slot-scope="text, list">
              <preview-image :data="text" :size="44" />
            </a-row>
            <a slot="action" slot-scope="text, list">
              <a class="m-r-10" @click="showFileDataModal(list)">编辑</a>
              <a-popconfirm title="确定删除?" @confirm="deleteFileData(list)"
                >删除</a-popconfirm
              >
            </a>
          </a-table>
        </section>
      </section>

      <section class="form-item m-t-10">
        <div class="form-btn-group" style="text-align: center; padding: 18px 0">
          <a-button
            @click="submit"
            :disabled="submitLoadding"
            :loading="submitLoadding"
          >
            <a-icon type="save" v-if="!submitLoadding" />保存
          </a-button>
          <a-button @click="$router.back()">取消</a-button>
        </div>
      </section>
      <select id="curDev" style="width: 90px; opacity: 0" name="selDev">
        <option value="0">E1500 Pro</option>
        <option value="1">USB CAM2</option>
      </select>
    </a-form>

    <!-- 文件照片 -->
    <div class="bankuai" v-if="fileModal.visible">
      <a-modal
        centered
        width="500px"
        class="modal-container quanzhong"
        :title="fileModal.title"
        v-model="fileModal.visible"
        :footer="false"
        :destroyOnClose="true"
      >
        <a-row type="flex">
          <a-col style="width: 400px">
            <a-row type="flex" style="height: 100%" justify="center">
              <!-- v-if="personnelFaceImage"
            :src="picServer + personnelFaceImage"-->
              <a-row
                style="
                  width: 300px;
                  height: 210px;
                  margin-top: 30px;
                  padding: 4px;
                  border-radius: 4px;
                  border: 1px solid rgba(255, 255, 255, 0.4);
                "
              >
                <img id="myCanvas" style="width: 100%; height: 100%" />
              </a-row>
            </a-row>
          </a-col>
        </a-row>
        <a-row class="form-btn-group m-t-18" style="text-align: center">
          <a-button @click="paizhao3" class="btn-save">{{ textP3 }}</a-button>
          <a-button class="btn-save" @click="baocun3">
            <a-icon type="save" />保存
          </a-button>
          <a-button class="btn-cancel" @click="quxiao3">取消</a-button>
        </a-row>
      </a-modal>
    </div>

    <!--资料文件  -->
    <a-modal
      centered
      width="660px"
      class="modal-container"
      :title="fileData.title"
      v-model="fileData.visible"
      :footer="false"
      :destroyOnClose="true"
    >
      <a-form :form="fileDataForm">
        <a-form-item
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 18 }"
          label="文件名称"
        >
          <a-input
            placeholder="请输入"
            v-decorator="[
              'fileName',
              { rules: [{ required: true, message: '文件名称不能为空' }] },
            ]"
            class="form-input"
          ></a-input>
        </a-form-item>
        <a-form-item
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 18 }"
          label="文件备注"
        >
          <a-textarea
            placeholder="请输入"
            :rows="4"
            v-decorator="[
              'remarks',
              {
                rules: [{ required: false, message: '请输入备注说明' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 18 }"
          label="附件"
        >
          <a-row type="flex">
            <a-button class="gpBtn gpBtnCard" @click="fileSbie('fileDataUrl')"
              >拍照</a-button
            >
            <upload
              @func="getFileDataFile"
              style="display: inline-block; width: 100px"
              v-decorator="[
                'fileUrl',
                { rules: [{ required: true, message: '请上传附件' }] },
              ]"
              :node="{ type: 3, text: '上传', icon: 'plus' }"
              :accept="['.png', '.jpg']"
            />
          </a-row>
          <a-row type="flex">
            <a-row class="upload-preview-wrap">
              <a v-if="fileData.files.url" class="file-item m-r-10">
                <preview-image :data="fileData.files.url" :size="100" />
              </a>
            </a-row>
          </a-row>
        </a-form-item>
        <a-row class="form-btn-group">
          <a-button class="btn-save" @click="saveFileData">
            <a-icon type="save" />保存
          </a-button>
          <a-button class="btn-cancel" @click="fileData.visible = false"
            >取消</a-button
          >
        </a-row>
      </a-form>
    </a-modal>
  </section>
</template>

<script>
import main from "../../labour/person/main.js"; //页面逻辑

import validator from "../../../../until/validator";
// import DataTransformUtils from "@/utils/DataTransformUtils";
import upload from "@/components/upload";
// import moment from "moment";
import previewImage from "@/components/previewImage";

const fileColumns = [
  { title: "序号", dataIndex: "key", align: "center", key: "key" },
  {
    title: "文件名称",
    dataIndex: "fileName",
    align: "center",
    key: "fileName",
  },
  {
    title: "附件",
    dataIndex: "fileUrl",
    align: "center",
    key: "fileUrl",
    scopedSlots: { customRender: "fileUrl" },
  },
  {
    title: "操作",
    align: "center",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];
export default {
  data() {
    return {
      validator,
      companyMap: [], //单位下拉列表
      carTypeMap: [], //车辆类型下拉列表
      companyTypeId: "",
      companyId: "",
      files: {},
      //资料文件
      fileData: {
        visible: false,
        title: "添加资料文件",
        key: "",
        columns: fileColumns,
        data: [],
        files: {},
      },
      personnelType: "", //人员类型（管理人员、施工人员）
      labourType: "", //施工人员类型
      teamRelativeId: "", //班组关联id

      fileModal: {
        visible: false,
        title: "文件拍照",
        currentDeviceCode: "",
        url: "",
      },

      textP3: "拍照",
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { first: true });
    this.fileDataForm = this.$form.createForm(this);
  },
  components: { upload, previewImage },
  computed: {
    cid() {
      return this.$route.query.id;
    },
    picServer() {
      return this.$store.state.picServer;
    },
    submitLoadding() {
      return this.$store.state.submitLoadding;
    },
  },
  created() {
    this.personnelType = this.$route.query.personnelType || "";
    this.init();
    if (this.cid) {
      this.queryCarDetails();
    } else {
      // this.$nextTick(() => {
      //   this.form.setFieldsValue({
      //     // maritalStatus: 1,
      //     sex: 1,
      //     nation: "汉族",
      //     // educationLevel: 5,
      //     liveBuiltBureau: 0,
      //   });
      // });
    }
  },
  mounted() {
    this.$nextTick(() => {
      main.load();
    });
  },
  methods: {
    init() {
      this.queryCompanyDropDownBox();
      this.queryCarTypeList();
    },
    //单位下拉
    queryCompanyDropDownBox() {
      this.$api.queryCompanyDropDownBox().then((res) => {
        if (res.code === 200) {
          this.companyMap = res.data || [];
        }
      });
    },
    //车辆类型下拉
    queryCarTypeList() {
      this.$api.queryCarTypeList({ size: 100 }).then((res) => {
        if (res.code === 200) {
          this.carTypeMap = res.data || [];
        }
      });
    },
    // 将输入的内容与显示的内容进行匹配
    filterOption(value, option) {
      return option.componentOptions.children[0].text.indexOf(value) >= 0;
    },
    uploadFile(file) {
      this.files = file;
      this.$nextTick(() => {
        this.form.setFieldsValue({
          carImage: file.codeUrl,
        });
      });
    },

    quxiao3() {
      this.fileModal.visible = false;
      main.stop_preview();
    },

    paizhao3() {
      if (this.textP3 == "拍照") {
        this.textP3 = "重新拍照";
        main.stop_preview();
      } else {
        this.textP3 = "拍照";
        main.start_preview();
      }
    },
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {
        type: mime,
      });
    },
    baocun3() {
      var myimg = document.getElementById("myCanvas");
      if (this.textP3 != "拍照") {
        let arr = this.dataURLtoFile(myimg.src, "idPhoto.png");
        arr.uid = "vc-upload-" + Date.parse(new Date());
        let url = this.fileModal.url;
        //文件上传对象
        let formData = new FormData();
        formData.append("file", arr);
        this.$api.uploadFile(formData).then((res) => {
          if (res.code === 200) {
            this.textP3 = "拍照";
            this.fileModal.visible = false;
            // this.avatar = this.picServer + res.data.codeUrl;
            if (url == "fileDataUrl") {
              this.fileData.files = res.data;
              this.fileData.files.url = res.data.codeUrl;
              this.fileModal.visible = false;
              this.$nextTick(() => {
                this.fileDataForm.setFieldsValue({
                  fileUrl: res.data.codeUrl,
                });
              });
            }
          }
        });
      } else {
        this.$message.error("请拍照后保存");
      }
    },

    fileSbie(url, name) {
      if (name) {
        this.licence.name = name;
      }
      this.fileModal.visible = true;
      this.fileModal.url = url;
      main.changedev(0);
      main.start_preview();
      main.RotateCrop(true);
    },

    //编辑时回填数据
    queryCarDetails() {
      this.$api.queryCarInfoDetails({ id: this.cid }).then((res) => {
        if (res.code === 200) {
          let _data = res.data || {};
          console.log(_data);
          let formData = {
            carBrand: _data.carBrand,
            carName: _data.carName,
            carNumber: _data.carNumber,
            companyId: _data.companyId,
            carType: _data.carType,
            carImage: _data.carImage ? _data.carImage : "",
            remarks:_data.remarks
          };
          this.files.url = _data.carImage ? _data.carImage.includes('http') ? _data.carImage : (this.picServer + _data.carImage ) : ''
          this.$nextTick(() => {
            this.form.setFieldsValue(formData);
          });
          //资料文件
          this.fileData.data = _data.carFileList || [];
          this.fileData.data.forEach((item, ind) => {
                item.key = ind + 1;
          });
        }
      });
    },

    //资料文件
    showFileDataModal(list) {
      this.fileData.visible = true;
      this.fileData.key = list ? list.key : "";
      this.fileData.files = {};
      if (list) {
        let formData = {
          fileName: list.fileName,
          remarks: list.remarks,
          fileUrl: list.fileUrl,
        };
        this.fileData.files = {
          url: list.fileUrl,
          fileUrl: list.fileUrl,
        };
        this.$nextTick(() => {
          this.fileDataForm.setFieldsValue(formData);
        });
      }
    },
    saveFileData() {
      this.fileDataForm.validateFields((err, formData) => {
        console.log(this.fileData.files);
        if (!err) {
          this.fileData.visible = false;
          formData.fileOriginName = this.fileData.files.fileName;
          // formData.fileRemark = this.fileData.files.fileRemark;
          if (this.fileData.key) {
            this.fileData.data.forEach((item) => {
              if (item.key == this.fileData.key) {
                item.remarks = formData.remarks;
                item.fileUrl = formData.fileUrl;
                item.fileName = formData.fileName;
              }
            });
          } else {
            formData.key = this.fileData.data.length + 1;
            this.fileData.data.push(formData);
          }
        }
      });
    },
    getFileDataFile(file) {
      this.fileData.files = file;
      this.$nextTick(() => {
        this.fileDataForm.setFieldsValue({
          fileUrl: file.codeUrl,
        });
      });
    },
    deleteFileData(list) {
      this.fileData.data = this.fileData.data.filter(
        (item) => item.fileUrl != list.fileUrl
      );
    },

    //新增和编辑提交表单
    submit() {
      this.form.validateFields((err, formData) => {
        if (!err) {
          if (this.cid) {
            formData.id = this.cid;
          }
          if (this.fileData.data.length) {
            formData.carFileList = this.fileData.data;
          }
          // console.log("---------------");
          // console.log(formData);
          let apiName = this.cid ? "updateCarInfo" : "insertCarInfo";
          this.$api[apiName](formData).then((res) => {
            if (res.code === 200) {
              this.$router.back();
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.gpBtn {
  padding: 22px 15px 40px 15px;
  margin-right: 10px;
  background: rgba(28, 61, 108, 0.5);
  border: 1px solid rgba(63, 114, 186, 0.5);
  color: #fff;
}
.gpBtnCard {
  background: #1c3d6c;
}
.quanzhong {
  z-index: 999999999;
  position: relative;
}
.bankuai {
  // background: red;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  // z-index: 1000;
  overflow: auto;
  outline: 0;
  z-index: 9999999;
}
</style>